/** Value shown in insight tables and Excel — single source of truth per column. */
export function cellValue(column, row) {
  if (typeof column.format === 'function') return column.format(row);
  const v = row[column.key];
  if (v == null || v === '') return '—';
  if (Array.isArray(v)) return v.join(', ');
  return String(v);
}
